module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Medium.f2426a5a.ttf";